
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useState } from "react";
import MobileMenuButton from "./mobile/MobileMenuButton";
import MobileMenuServices from "./mobile/MobileMenuServices";

interface NavbarMobileMenuProps {
  isMenuOpen: boolean;
  setIsMenuOpen: (isOpen: boolean) => void;
  scrollToServices: () => void;
}

export const NavbarMobileMenu = ({
  isMenuOpen,
  setIsMenuOpen,
  scrollToServices,
}: NavbarMobileMenuProps) => {
  const [showServices, setShowServices] = useState(false);

  return (
    <div className="relative z-50">
      <MobileMenuButton 
        isOpen={isMenuOpen} 
        onClick={() => setIsMenuOpen(!isMenuOpen)} 
      />
      
      <div 
        className={`fixed inset-0 bg-[#1A1F2C]/95 backdrop-blur-sm transition-all duration-300 ${
          isMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setIsMenuOpen(false)}
      />
      
      {isMenuOpen && (
        <div 
          className="fixed inset-x-0 top-[4rem] bottom-0 bg-gradient-to-b from-[#1A1F2C] to-[#2A2F3C] p-6 overflow-y-auto animate-slide-in-right"
          onClick={(e) => e.stopPropagation()}
        >
          <Link
            to="/"
            className="flex items-center gap-2 text-white/80 hover:text-white mb-6 group"
            onClick={() => setIsMenuOpen(false)}
          >
            <ArrowLeft className="h-5 w-5 transition-transform group-hover:-translate-x-1" />
            <span>Back to Home</span>
          </Link>
          
          <div className="flex flex-col space-y-4">
            <MobileMenuServices
              showServices={showServices}
              onServiceClick={() => {
                setIsMenuOpen(false);
                setShowServices(false);
              }}
              onToggleServices={() => setShowServices(!showServices)}
            />
            
            <Link
              to="/advantages"
              className="text-lg font-medium text-white/90 hover:text-white px-4 py-3 rounded-lg hover:bg-white/10 transition-all duration-300"
              onClick={() => setIsMenuOpen(false)}
            >
              FAQ
            </Link>
            
            <Link
              to="/about"
              className="text-lg font-medium text-white/90 hover:text-white px-4 py-3 rounded-lg hover:bg-white/10 transition-all duration-300"
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </Link>
            
            <Link
              to="/contact"
              className="text-lg font-medium text-white/90 hover:text-white px-4 py-3 rounded-lg hover:bg-white/10 transition-all duration-300"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>
            
            <a
              href="tel:416-805-5075"
              className="mt-4 bg-gradient-to-r from-primary to-primary-hover text-white font-medium px-6 py-4 rounded-lg text-center shadow-lg transform hover:scale-105 transition-all duration-300"
              onClick={() => setIsMenuOpen(false)}
            >
              Call Now
            </a>
          </div>
        </div>
      )}
    </div>
  );
};
